export const getCurrentHostname = () => {
  const { hostname } = window.location;
  const parts = hostname.split('.');
  if (parts.length > 0) {
    return parts[0];
  }
  return '';
};
